module.exports = __webpack_public_path__ + "img/check-success.a3ebe856.png";